// import { createContext, useContext, useState } from "react";

// const OverlaySidebarContext = createContext();

// export const OverlaySidebarProvider = ({ children }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const openOverlay = () => setIsOpen(true);
//   const closeOverlay = () => setIsOpen(false);
//   const toggleOverlay = () => setIsOpen(prev => !prev);

//   return (
//     <OverlaySidebarContext.Provider value={{ isOpen, openOverlay, closeOverlay, toggleOverlay }}>
//       {children}
//     </OverlaySidebarContext.Provider>
//   );
// };

// export const useOverlaySidebar = () => useContext(OverlaySidebarContext);

import { createContext, useContext, useState, useRef } from "react";

const OverlaySidebarContext = createContext();

export const OverlaySidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const onCloseCallbackRef = useRef(null); // store callback safely

  const openOverlay = () => setIsOpen(true);

  const closeOverlay = () => {
    setIsOpen(false);

    // 🔥 Always call the latest callback
    if (onCloseCallbackRef.current) {
      onCloseCallbackRef.current();
    }
  };

  const toggleOverlay = () => setIsOpen(prev => !prev);

  const setOnCloseCallback = (callback) => {
    onCloseCallbackRef.current = callback;
  };

  return (
    <OverlaySidebarContext.Provider
      value={{
        isOpen,
        openOverlay,
        closeOverlay,
        toggleOverlay,
        setOnCloseCallback
      }}
    >
      {children}
    </OverlaySidebarContext.Provider>
  );
};

export const useOverlaySidebar = () => useContext(OverlaySidebarContext);
